import "./AdvantagesBanner.css";

const AdvantagesBanner = () => {
  return (
    <div id="advantages" className="advantages-banner">
      <div className="advantages-banner__content">
        <h2 className="advantages-banner__title">
          Why Teams Choose Quad Theory For Mobile Apps That Survive Reality
        </h2>
      </div>
      <div className="advantages-banner__illustration"></div>
    </div>
  );
};

export default AdvantagesBanner;
